export enum Role {
  SUPER_ADMIN = 'SUPER_ADMIN',
  VENDOR = 'VENDOR',
  VENDOR_STAFF = 'VENDOR_STAFF',
  CUSTOMER = 'CUSTOMER',
}

// Alias for backwards compatibility
export { Role as UserRole };

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: Role;
  avatar?: string;
  isVerified: boolean;
  isEmailVerified: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Vendor {
  id: string;
  userId: string;
  businessName: string;
  description?: string;
  logo?: string;
  isVerified: boolean;
  verifiedAt?: string;
  fssaiLicenseNumber?: string;
  createdAt: string;
  updatedAt: string;
}

export enum StaffPermission {
  VIEW_BOOKINGS = 'VIEW_BOOKINGS',
  MANAGE_BOOKINGS = 'MANAGE_BOOKINGS',
  VIEW_REVENUE = 'VIEW_REVENUE',
  VIEW_PAYOUTS = 'VIEW_PAYOUTS',
  MANAGE_AVAILABILITY = 'MANAGE_AVAILABILITY',
  MANAGE_VENUE_DETAILS = 'MANAGE_VENUE_DETAILS',
  VIEW_REVIEWS = 'VIEW_REVIEWS',
  RESPOND_TO_REVIEWS = 'RESPOND_TO_REVIEWS',
  MANAGE_COUPONS = 'MANAGE_COUPONS',
  VIEW_CUSTOMERS = 'VIEW_CUSTOMERS',
  VIEW_STAFF = 'VIEW_STAFF',
  MANAGE_STAFF = 'MANAGE_STAFF',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
}

export interface VendorStaff {
  id: string;
  vendorId: string;
  userId: string;
  permissions: StaffPermission[];
  assignedVenues: string[];
  isActive: boolean;
  invitedBy: string;
  invitedAt: string;
}

export interface StaffInvitation {
  id: string;
  vendorId: string;
  email: string;
  firstName: string;
  lastName: string;
  permissions: StaffPermission[];
  assignedVenues: string[];
  token: string;
  expiresAt: string;
  invitedBy: string;
  createdAt: string;
}

/**
 * Staff member with user details
 */
export interface StaffMember extends VendorStaff {
  user: Pick<User, 'id' | 'email' | 'firstName' | 'lastName' | 'avatar'>;
  lastActive?: string;
}
